import { useQuery } from '@tanstack/react-query';
import { apiConnectionApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useApiConnections() {
  return useQuery({
    queryKey: queryKeys.organization.apiConnections(),
    queryFn: ({ signal }) => apiConnectionApiClient.list(toCancelToken(signal)),
    staleTime: 60_000,
    meta: {
      errorContext: 'API connections',
    },
  });
}
